import styled, { css, keyframes } from "styled-components";

import Props from "./props";

const dash = keyframes`
    0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
    }
    100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
    }
`;

const color = keyframes`
    100%,
    0% {
        stroke: #d62d20;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #008744;
    }
    80%,
    90% {
        stroke: #ffa700;
    }
`;

const Path = styled.circle<Props>`
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    ${(props: Props) => {
        if (props.primary) {
            return css`
                animation: ${dash} 1.5s ease-in-out infinite;
                stroke: ${props => props.theme.colors.primary(1)};
            `;
        } else if (props.light) {
            return css`
                animation: ${dash} 1.5s ease-in-out infinite;
                stroke: ${props => props.theme.colors.light(1)};
            `;
        } else {
            return css`
                animation: ${dash} 1.5s ease-in-out infinite, ${color} 6s ease-in-out infinite;
            `;
        }
    }}
`;

export default Path;
